import React from 'react'
import { Formik } from 'formik'
import { Paper, Typography, FormControl, InputLabel, Input, Button } from '@material-ui/core'
import {Link, NavLink} from 'react-router-dom'
import { ILoginUserInput } from 'app/shared/data-access/users/login-user/login-user-input'
import { useStyles } from './forgot-password.styles'
import * as yup from 'yup'

type Props = {
  onSendForgotPassword: (email: string) => Promise<void>
  isBusy: boolean
}

const ForgotPasswordView = (props: Props) => {
  const classes = useStyles()

  const validateSchema = yup.object().shape({
    email: yup.string().email('Geen geldig e-mailadres').required('Dit veld is verplicht'),
  })

  return (
    <main className={classes.main}>
      <Paper className={classes.paper}>
          <Link to={{ pathname: `//axs-ict.com` }} target="_blank" >
              <img src="/axs_logo_payoff.png" className={classes.branding} alt="AXS logo" />
          </Link>
        <Typography component="h1" variant="h5">
          Wachtwoord vergeten
        </Typography>
        <Formik
          initialValues={{ email: '' } as ILoginUserInput}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(false)
            await props.onSendForgotPassword(values.email)
          }}
          validationSchema={validateSchema}
        >
          {({ errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, initialValues, isValid }) => (
            <form className={classes.form} onSubmit={handleSubmit}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="email">E-mail</InputLabel>
                <Input
                  defaultValue={initialValues.email}
                  id="email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <div>
                  <label className={classes.errorLabel}>{errors.email && touched.email && errors.email}</label>
                </div>
              </FormControl>

              <Button
                disabled={props.isBusy || isSubmitting || !isValid}
                onClick={(e: React.MouseEvent | React.KeyboardEvent) => {
                  e.preventDefault()
                  handleSubmit()
                }}
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Versturen
              </Button>
              <NavLink to="/login">Terug naar inloggen</NavLink>
            </form>
          )}
        </Formik>
      </Paper>
    </main>
  )
}

export default ForgotPasswordView
